/* global $ */
(function (angular) {
  angular.module("app").controller("messagesController", messagesController);

  messagesController.$inject = [
    "alerts",
    "$rootScope",
    "confirmDialog",
    "MessagePostsApi",
    "MessageUsersApi",
    "MessageThreadsApi",
    "MessageGroupsApi",
    "MessageGroupPostsApi",
    "MessageGroupUsersApi",
    "Helpers",
    "Users",
    "$timeout",
    "UsersApi",
    "ConnectsApi",
  ];

  function messagesController(
    alerts,
    $rootScope,
    confirmDialog,
    MessagePostsApi,
    MessageUsersApi,
    MessageThreadsApi,
    MessageGroupsApi,
    MessageGroupPostsApi,
    MessageGroupUsersApi,
    Helpers,
    Users,
    $timeout,
    UsersApi,
    ConnectsApi,
  ) {
    const vm = this;
    const down = {};

    // properties
    vm.isLoadingConversations = false;
    vm.isLoadingMessages = false;
    vm.deletingConversation = false;
    vm.conversations = {};
    vm.groupConversations = {};
    vm.totalConversations = {};
    vm.messages = {};
    vm.selectedConversation = null;
    vm.reply = null;
    vm.selectedUser = [];
    vm.users = [];

    vm.message = "";
    vm.previousSearch = "";
    vm.formErrors = {};

    // methods
    vm.scrollToBottom = scrollToBottom;
    vm.getConversations = getConversations;
    vm.newMessage = newMessage;
    vm.deleteConversation = deleteConversation;
    vm.getMessages = getMessages;
    vm.getGroupMessages = getGroupMessages;
    vm.sendReply = sendReply;
    vm.resend = resend;
    vm.filterUsers = filterUsers;
    vm.sendMessage = sendMessage;

    if (Users.id) {
      getReceipient();
    }

    /**
     * Gets the user we're sending this message to
     * @return {void}
     */
    function getReceipient() {
      vm.isLoadingMessage = "Loading user...";
      vm.isLoading = true;

      UsersApi.get(
        {
          id: Users.id,
        },
        (response) => {
          // keep the data structure the same as when we're
          vm.selectedUser = response.data;
          vm.isLoading = false;
        },
        () => {
          vm.isLoading = false;
        },
      );
    }
    /**
     * Searches connected users by the provided string and assigns to scope
     * @param  {string} search - full name or email
     * @return {void}
     */
    function filterUsers(search) {
      if (!search || search === "" || search === vm.previousSearch) {
        return false;
      }
      vm.previousSearch = search;

      // Reset the timer (make sure we wait 300ms after the user stops typing)
      if (vm.filterTimeout) {
        $timeout.cancel(vm.filterTimeout);
      }

      vm.filterTimeout = $timeout(() => {
        // Clear current results
        vm.users = [];

        // Search for users
        ConnectsApi.get({ full_name: search }, (response) => {
          angular.forEach(response.data, (connect) => {
            vm.users.push(connect.user_to);
          });
        });
        ConnectsApi.get({ email: search }, (response) => {
          angular.forEach(response.data, (connect) => {
            vm.users.push(connect.user_to);
          });
        });
      }, 300);
    }
    /**
     * Sends message to the user
     * @return {void}
     */
    function sendMessage() {
      vm.formErrors = {};

      if (!vm.selectedUser || vm.selectedUser.length === 0) {
        vm.formErrors.user = ["Choose a recipient"];
      }
      if (!vm.message || vm.message === "") {
        vm.formErrors.message = ["Message required"];
      }

      if (Object.keys(vm.formErrors).length) {
        return false;
      }

      vm.isLoading = true;

      // if only single message send to 1 person
      // if more than 1 then we need to post somewhere else.
      if (vm.selectedUser.length === 1) {
        vm.selectedUser = vm.selectedUser[0];

        MessageThreadsApi.save(
          {
            user_id: vm.selectedUser.id,
            body: vm.message,
          },
          (response) => {
            alerts.emit({
              theme: "success",
              title: "Message Sent",
            });

            vm.reply = null;

            MessageUsersApi.get((response) => {
              vm.conversations = getConversations();
              vm.isLoadingConversations = false;
              getMessages(response.data[0]);
            });

            $timeout(() => {
              scrollToBottom();
            }, 100);
            vm.message = null;
            vm.isLoading = false;
          },
          () => {
            vm.isLoading = false;
          },
        );
      } else {
        MessageGroupsApi.save(
          {
            users: vm.selectedUser,
            body: vm.message,
          },
          (response) => {
            alerts.emit({
              theme: "success",
              title: "Message Sent",
            });
            const groupMessageThreadId = response.data.id;
            vm.reply = null;
            MessageGroupUsersApi.get((response) => {
              vm.conversations = getConversations();
              vm.isLoadingConversations = false;
              angular.forEach(response.data, (record) => {
                if (record.group_message_thread_id === groupMessageThreadId) {
                  getGroupMessages(record);
                }
              });
            });

            $timeout(() => {
              scrollToBottom();
            }, 100);
            vm.message = null;
            vm.isLoading = false;
          },
          () => {
            vm.isLoading = false;
          },
        );
      }
    }
    // send message on cmd + enter
    $(document)
      .keydown((e) => {
        down[e.keyCode] = true;
      })
      .keyup((e) => {
        if (down[91] && down[13]) {
          if ($("#messages").has(":focus")) {
            sendReply();
          }
        }
        down[e.keyCode] = false;
      });

    /**
     * Scrolls to the bottom of the message window
     * @return {void}
     */
    function scrollToBottom() {
      const box = $("#messages");
      box.animate({ scrollTop: box[0].scrollHeight }, 50);
    }

    /**
     * Retrieves conversations (messageUsers) from the API
     * @return {void}
     */
    function getConversations() {
      vm.isLoadingConversations = true;

      MessageUsersApi.get(
        (response) => {
          vm.conversations = response.singleMessages;
          vm.groupConversations = response.groupMessages;
          vm.totalConversations = response.totalConversations;
          vm.isLoadingConversations = false;
        },
        () => {
          vm.isLoadingConversations = false;
        },
      );
    }

    /**
     * Opens the send new message modal, then refreshes the conversation list
     * @return {void}
     */
    function newMessage() {
      Users.sendMessage().result.then(() => {
        getConversations();
      });
    }

    /**
     * Sends a delete request for the provided conversation and removes from the view
     * @param  {object} conversation - conversation (messageUser) object containing "message_thread_id"
     * @return {void}
     */
    function deleteConversation(conversation) {
      vm.deletingConversation = true;

      vm.isLoadingConversations = true;

      confirmDialog(
        "Are you sure you want to delete this conversation?",
      ).result.then((confirm) => {
        if (!confirm) {
          vm.isLoadingConversations = false;
          vm.deletingConversation = false;
          return false;
        }

        MessageUsersApi.delete(
          {
            id: conversation.id,
          },
          () => {
            // remove conversation locally
            vm.conversations.data.splice(
              vm.conversations.data.indexOf(conversation),
              1,
            );
            vm.isLoadingConversations = false;
            vm.deletingConversation = false;
          },
          () => {
            vm.isLoadingConversations = false;
            vm.deletingConversation = false;
          },
        );
      });
    }
    // populate the receipient dropdown
    ConnectsApi.get((response) => {
      angular.forEach(response.data, (connect) => {
        vm.users.push(connect.user_to);
      });
    });

    /**
     * Retrieves messages from the API for a specified conversation
     * @param  {object} conversation - "conversation" (messageUsers) object containing "message_thread_id"
     * @return {void}
     */
    function getMessages(conversation) {
      if (vm.deletingConversation) {
        return false;
      }

      vm.isLoadingMessages = true;

      MessagePostsApi.get(
        { message_thread_id: conversation.message_thread_id },
        (response) => {
          vm.messages = response;
          vm.selectedConversation = conversation;
          vm.isLoadingMessages = false;
          vm.selectedUser = [conversation.user];
          vm.selectedUser.full_name = `${conversation.user.forename} ${conversation.user.surname}`;

          // reset this thread's unread messages
          vm.selectedConversation.total_unread_posts = 0;

          // focus cursor on reply textarea
          $timeout(() => {
            scrollToBottom();
            $("#reply-textarea").focus();
          }, 400);
        },
        () => {
          vm.isLoadingMessages = false;
        },
      );
    }

    /**
     * Retrieves messages from the API for a specified conversation
     * @param  {object} conversation - "conversation" (messageUsers) object containing "message_thread_id"
     * @return {void}
     */
    function getGroupMessages(conversation) {
      if (vm.deletingConversation) {
        return false;
      }

      vm.isLoadingMessages = true;

      MessageGroupPostsApi.get(
        { group_message_thread_id: conversation.group_message_thread_id },
        (response) => {
          vm.messages = response;
          vm.selectedConversation = conversation;
          vm.isLoadingMessages = false;
          vm.selectedUser = response.users;

          let fullName = "";
          vm.selectedUser.forEach(function (value) {
            fullName = fullName + value.full_name + " / ";
          });

          vm.selectedUser.full_name = fullName.slice(0, -2);
          vm.selectedUser.initials = "GM";
          vm.selectedUser.img = "";

          // reset this thread's unread messages
          vm.selectedConversation.total_unread_posts = 0;

          // focus cursor on reply textarea
          $timeout(() => {
            scrollToBottom();
            $("#reply-textarea").focus();
          }, 400);
        },
        () => {
          vm.isLoadingMessages = false;
        },
      );
    }

    /**
     * Posts a message to the current conversation
     * @return {void}
     */
    function sendReply() {
      if (!vm.reply) {
        return false;
      }

      const tempId = +new Date();
      const reply = Helpers.escapeHtml(angular.copy(vm.reply));
      vm.reply = null;

      // add message to the UI immediately
      vm.messages.data.push({
        temp_id: tempId,
        user_id: vm.selectedConversation.user.id,
        user: $rootScope.thisUser,
        created_at: window.moment().format("YYYY-MM-DD HH:mm:ss"),
        body: reply,
      });

      $timeout(() => {
        scrollToBottom();
      }, 100);

      function setErrorMessage(errorMessage, canResend) {
        angular.forEach(vm.messages.data, (message) => {
          if (message.temp_id === tempId) {
            message.error = {
              message: errorMessage,
              canResend,
            };
          }
        });
      }

      MessageThreadsApi.save(
        {
          user_id: vm.selectedConversation.user.id,
          body: reply,
        },
        (response) => {
          if (!response || !response.data) {
            // user is probably offline
            setErrorMessage("", false);
            return false;
          }

          vm.selectedConversation.message_thread.body_excerpt =
            response.data.body_excerpt;
          // no need to do anything...
        },
        (response) => {
          if (response.status === 403) {
            setErrorMessage(response.data[0], false);
          } else {
            // not sent. add error to offline message
            setErrorMessage("Couldn't send. Click here to try again.", true);
          }
        },
      );
    }

    /**
     * Attempts to resent an error that wasn't sent due to an error
     * @param  {object} offineMessage - containing "temp_id" and "body" and "user_id"
     * @return {void}
     */
    function resend(offlineMessage) {
      if (!offlineMessage.error.canResend) {
        return false;
      }

      offlineMessage.error = null;
      offlineMessage.resending = true;

      function setErrorMessage() {
        offlineMessage.resending = false;
        offlineMessage.error = "Couldn't send. Click here to try again.";
      }

      MessageThreadsApi.save(
        {
          user_id: offlineMessage.user_id,
          body: offlineMessage.body,
        },
        (response) => {
          if (!response || !response.data) {
            // user is probably offline
            setErrorMessage();
            return false;
          }

          offlineMessage.resending = false;
          vm.selectedConversation.message_thread.body_excerpt =
            response.data.body_excerpt;
        },
        (response) => {
          if (response.status === 403) {
            // not connected to this user
            alerts.emit({
              theme: "error",
              title: "Message could not be sent",
              messages: [
                "You must be connected to this person before you can send them a message",
              ],
            });
          }

          setErrorMessage();
        },
      );
    }

    getConversations();
  }
})(angular);
